import { useFormContext } from 'react-hook-form';
import { SelectedPurposeOfUseOrContact } from '../../../common/enums.js';
import { purposeOfUseExampleMsg, purposeOfUseMsg, t } from '../../../common/i18n/index.js';
import { TextInput } from '../../../common/react-hook-form/fields/TextInput.js';
import type { ContactOrPurposeOfUseFormValues } from '../ContactsOrPurposeOfUseUtils.js';

interface PurposeOfUseFormProps {
  required?: boolean;
}

export const PurposeOfUseForm = ({ required }: PurposeOfUseFormProps) => {
  const { watch } = useFormContext<ContactOrPurposeOfUseFormValues>();
  const selectionTab = watch('selectionTab');

  if (selectionTab !== SelectedPurposeOfUseOrContact.PURPOSEOFUSE) {
    return null;
  }
  return (
    <div className="of-contact-or-purpose-of-use__purpose_of_use_form">
      <TextInput
        name="purposeOfUse"
        hint={t.TTZ4(purposeOfUseExampleMsg)}
        maxLength={100}
        placeholder={t.Y8KX(purposeOfUseMsg)}
        label=""
        required={required}
      />
    </div>
  );
};
